module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "site"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('Button', {
    staticStyle: {
      "margin": "10px 10px 10px 25px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.back($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.back))]), _vm._v(" "), _vm._l((_vm.sites[_vm.siteindex].pictures), function(picture, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticStyle: {
        "margin": "25px",
        "max-width": "100%"
      }
    }, [_c('img', {
      staticStyle: {
        "max-width": "100%"
      },
      attrs: {
        "src": picture
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticStyle: {
      "border-left": "3px solid #bbb",
      "padding-left": "10px",
      "font-size": "20px",
      "margin-bottom": "20px"
    }
  }, [_vm._v(_vm._s(_vm.showName(_vm.sites[_vm.siteindex])))]), _vm._v(" "), _c('div', {
    staticClass: "site_link",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction(_vm.sites[_vm.siteindex]))
    }
  })])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d5b5b05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SiteInfo.vue
// module id = 1236
// module chunks = 4